// extracted by mini-css-extract-plugin
export default {"label":"custom-label_label__nDQVw"};